import React from 'react';
import { FolderOpen } from 'lucide-react';

/**
 * The dashed drop zone row from `design/RFQ Wizard v2.dc.html`:
 * folder-open medallion, "Drop files here, or browse", accepted-type mono
 * row. Presentational; react-dropzone props are injected by the connected
 * caller (absent in the /design gallery). The mono row must state what the
 * caller's endpoint truly accepts — override it when the list differs.
 */

export interface UploadDropZoneProps {
  rootProps?: React.HTMLAttributes<HTMLElement>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  isDragActive?: boolean;
  typesLabel?: string;
}

export const UploadDropZone: React.FC<UploadDropZoneProps> = ({
  rootProps,
  inputProps,
  isDragActive = false,
  typesLabel = 'PDF · XLSX · DOCX · CSV · IMG',
}) => (
  <div
    {...rootProps}
    className={`flex cursor-pointer flex-wrap items-center justify-center gap-[14px] rounded-[9px] border-[1.5px] border-dashed border-action-border p-[22px] transition-colors ${
      isDragActive ? 'bg-action-bg' : 'bg-[#F7FAFF] hover:bg-action-bg'
    }`}
  >
    {inputProps && <input {...inputProps} />}
    <span className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-round border border-[#D6E4FF] bg-surface">
      <FolderOpen className="h-[18px] w-[18px] text-action" />
    </span>
    <span className="text-[14.5px] font-semibold text-action">Drop files here, or browse</span>
    <span className="font-mono text-[11px] text-ink-muted">{typesLabel}</span>
  </div>
);

export default UploadDropZone;
